import React from 'react';
import Timeline from '../../components/Timeline/Timeline';
import FontAwesome from 'react-fontawesome';
import Link from '../../components/Link/Link';
import Bullet from '../../components/Bullet/Bullet';
import SafecoExplainer from '../../containers/SafecoExplainer/SafecoExplainer';

const WhatsHappening = ({
    priorCarrier,
    showCarrierAsResearchParty = true,
    lineOfBusiness = '',
    urlText,
    publicityUrl,
    showPolicyTerminationBulletPoint = true,
    overwriteText
}) => {
    const defaultText = `Your current insurance provider, ${priorCarrier}, has made the decision to exit ${lineOfBusiness}, which impacts your policy. After careful research, ${
        showCarrierAsResearchParty ? priorCarrier + ' and' : ''
    }
    your agent selected Safeco Insurance as your new insurance provider based on our best-in-class products, pricing and technology. Check out some steps below to help you
    get started with Safeco and your new policy.`;

    const whatsHappeningText = overwriteText ? overwriteText : defaultText;
    return (
        <Timeline
            seperator="WELCOME ABOARD"
            heading="what's happening"
            icon={
                <FontAwesome
                    className="primary-yellow con md image_center icon15"
                    name="question"
                    datacy="question"
                    size="2x"
                />
            }>
            {whatsHappeningText}
            {publicityUrl ? (
                <div className="list">
                    <Bullet icon="chevron-right">
                        <Link
                            text={`Learn more about ${
                                urlText ? urlText : `${priorCarrier}'s`
                            } transition`}
                            linkURL={publicityUrl}
                            datacy="learn-more-transition"
                        />
                    </Bullet>
                </div>
            ) : (
                ''
            )}

            <h3 className="heading">what to expect</h3>
            <div className="list column">
                <Bullet icon="circle">Your agent will not change.</Bullet>
                {showPolicyTerminationBulletPoint ? (
                    <Bullet icon="circle">
                        {`Effective on the expiration date of your current ${priorCarrier} policy, you will no longer
                    have your insurance coverage through ${priorCarrier}  Insurance.`}
                    </Bullet>
                ) : (
                    ''
                )}
                <Bullet icon="circle">
                    {`Safeco is excited to offer you a quality insurance product that begins on the
                    expiration date of your ${priorCarrier} policy.`}
                </Bullet>
            </div>
            <h3 className="heading">who we are</h3>
            <SafecoExplainer />
        </Timeline>
    );
};

export default WhatsHappening;



// WEBPACK FOOTER //
// ./src/containers/WhatsHappening/WhatsHappening.jsx